import React from 'react';
import { UserPlus, Package, ClipboardList, Truck, Receipt, IndianRupee } from 'lucide-react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';

const steps = [
  { icon: UserPlus, title: 'Create business account', desc: 'Sign up in 30 seconds. Add your business name and city.' },
  { icon: Package, title: 'Add products', desc: 'Add any recurring product or service you deliver.' },
  { icon: UserPlus, title: 'Add customers', desc: 'Type them in, or import a CSV. Set address, area, delivery notes.' },
  { icon: ClipboardList, title: 'Create subscriptions', desc: 'How much, how often, which days. Pause any time.' },
  { icon: Truck, title: 'Manage deliveries', desc: 'One-tap "delivered" for a whole route. Only edit exceptions.' },
  { icon: Receipt, title: 'Bill & collect', desc: 'Auto invoices, share via WhatsApp. Track cash, UPI, bank.' },
];

export default function HowToUse() {
  return (
    <div className="bg-rozops-bg min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-rozops-blue-light text-rozops-blue text-xs font-semibold px-3 py-1">Getting started</div>
          <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rozops-navy tracking-tight">Start using RozOps in a few simple steps</h1>
          <p className="mt-4 text-lg text-rozops-text-muted">No technical knowledge needed. If you can send a WhatsApp, you can run your business on RozOps.</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-lg bg-rozops-blue text-white grid place-items-center font-heading font-bold">{i + 1}</div>
                <div className="w-11 h-11 rounded-xl bg-rozops-blue-light text-rozops-blue grid place-items-center">
                  <Icon className="w-5 h-5" strokeWidth={2.2} />
                </div>
              </div>
              <div className="font-heading font-bold text-lg text-rozops-navy">{title}</div>
              <div className="text-sm text-rozops-text-muted mt-1">{desc}</div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
